/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Rejection_Reason_LabelInputs */

const en_admin_registration_rejection_reason_label = /** @type {(inputs: Admin_Registration_Rejection_Reason_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejection Reason`)
};

const de_admin_registration_rejection_reason_label = /** @type {(inputs: Admin_Registration_Rejection_Reason_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begründung der Ablehnung`)
};

/**
* | output |
* | --- |
* | "Rejection Reason" |
*
* @param {Admin_Registration_Rejection_Reason_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_rejection_reason_label = /** @type {((inputs?: Admin_Registration_Rejection_Reason_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Rejection_Reason_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_rejection_reason_label(inputs)
	return en_admin_registration_rejection_reason_label(inputs)
});